(function () {
  var MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

  function setExpanded(col, expanded) {
    col.classList.toggle('is-expanded', expanded);
    var toggle = col.querySelector('[data-sitemap-toggle]');
    if (toggle) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }

  function applyLayout() {
    var cols = document.querySelectorAll('[data-sitemap-col]');
    if (!cols.length) return;

    cols.forEach(function (col) {
      setExpanded(col, true);
    });
  }

  function bindMobileAccordion() {
    var cols = document.querySelectorAll('[data-sitemap-col]');
    if (!cols.length) return;

    cols.forEach(function (col) {
      var toggle = col.querySelector('[data-sitemap-toggle]');
      if (!toggle || toggle.dataset.bound === 'true') return;

      toggle.dataset.bound = 'true';
      toggle.addEventListener('click', function () {
        if (!MOBILE_QUERY.matches) return;

        var isExpanded = col.classList.contains('is-expanded');
        setExpanded(col, !isExpanded);
      });
    });
  }

  function init() {
    applyLayout();
    bindMobileAccordion();

    var onChange = function () {
      applyLayout();
    };

    if (typeof MOBILE_QUERY.addEventListener === 'function') {
      MOBILE_QUERY.addEventListener('change', onChange);
    } else if (typeof MOBILE_QUERY.addListener === 'function') {
      MOBILE_QUERY.addListener(onChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
